export interface ReportStruct {
  Name: string;
  Type: ReportType;
  Data?: number[] | null;
  Studies?: number[];
  IdCst?: number;
  IdUser?: number;
}

export enum ReportType {
  System = 1,
  WorkList = 2,
  Report = 3,
  DataGrid = 4,
  DashBoard = 5,
  Consentimiento = 6
}

export const ReportTypeList = [
  { value: 1, label: 'Sistema' },
  { value: 2, label: 'Lista de trabajo' },
  { value: 3, label: 'Informe' },
  { value: 4, label: 'Tablero de control' },
  { value: 5, label: 'DashBoard' },
];
